import React from 'react';

const Popup = (props) => {

    var popupMarginTop = (props.marginTopAdditionalPx ? ((11 + parseInt(props.marginTopAdditionalPx)) + "px") : null);
    var marginLeft = props.disableMarginLeft ? "0px" : null;
    var width = props.width;

    return (
        <div
            className={"popup-inside " + (props.className == null ? '' : props.className)}
            style={{ marginLeft: marginLeft, marginRight: props.marginRight }}>
            {props.children}
            <div className="popup" style={{ marginTop: popupMarginTop }}>
                <div className="popup-text" style={{ width: width }}>
                    {props.popupText}
                </div>
            </div>
        </div>
    );
}

export default Popup;